import { defaultFill } from '../../../utils/constants';
var muiInProgressBase = {
    paths: [
        {
            path: 'M8.88 1.037C8.88.382 8.283-.12 7.657.025a10.059 10.059 0 00-3.154 1.329c-.536.348-.617 1.125-.162 1.585.323.327.839.409 1.223.164a7.837 7.837 0 012.568-1.074c.445-.102.748-.522.748-.992zM2.916 4.39c-.466-.46-1.224-.389-1.567.164a10.303 10.303 0 00-1.315 3.19 1.017 1.017 0 00.991 1.238c.455 0 .88-.307.97-.757.203-.93.577-1.81 1.062-2.587.263-.4.182-.92-.141-1.248zm-1.89 6.637c-.648 0-1.143.603-1.002 1.237a10.407 10.407 0 001.314 3.19 1.003 1.003 0 001.567.164c.324-.327.405-.849.152-1.237a7.882 7.882 0 01-1.061-2.587c-.091-.46-.506-.767-.97-.767zm3.477 7.618a10.16 10.16 0 003.154 1.33c.626.143 1.223-.359 1.223-1.003 0-.46-.303-.89-.748-.981a8.008 8.008 0 01-2.558-1.074.975.975 0 00-1.223.163 1.001 1.001 0 00.152 1.565zM20 10.006c0 4.836-3.336 8.906-7.814 9.96-.627.153-1.234-.349-1.234-1.003 0-.47.314-.88.758-.992 3.59-.838 6.268-4.09 6.268-7.966 0-3.876-2.679-7.127-6.268-7.966-.444-.102-.758-.521-.758-.992 0-.654.607-1.155 1.234-1.002C16.664 1.098 20 5.168 20 10.005z',
            fill: defaultFill,
        },
    ],
    title: 'In Progress',
    width: 20,
    height: 20,
};
var muiInProgress = {
    base: muiInProgressBase,
};
export { muiInProgress };
//# sourceMappingURL=inProgress.js.map